import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { Container, Table, Alert, Button } from 'react-bootstrap';
import { PDFDocument, rgb } from 'pdf-lib';
import download from 'downloadjs';
import fontkit from '@pdf-lib/fontkit';

const CategoryOrderStats = () => {
  const { categoryId } = useParams();
  const [stats, setStats] = useState({});
  const [error, setError] = useState('');

  const fontUrl = `${window.location.origin}/fonts/NotoSansTC-Regular.ttf`;

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`https://shopapi.nogi46.me/api/orders/category/${categoryId}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        setStats(response.data);
      } catch (error) {
        setError('無法獲取統計數據，請稍後再試。');
      }
    };

    fetchStats();
  }, [categoryId]);

  const renderTable = (data) => {
    const combinations = Object.entries(data.sizeMemberCombinations)
      .map(([key, quantity]) => {
        const [size, member] = key.split('-');
        return { size, member, quantity };
      })
      .sort((a, b) => {
        if (a.member < b.member) return -1;
        if (a.member > b.member) return 1;
        if (a.size < b.size) return -1;
        if (a.size > b.size) return 1;
        return 0;
      });

    const hasSize = combinations.some((combination) => combination.size && combination.size !== '無尺寸');
    const hasMember = combinations.some((combination) => combination.member);

    return (
      <Table striped bordered hover>
        <thead>
          <tr>
            {hasMember && <th>成員</th>}
            {hasSize && <th>尺寸</th>}
            <th>數量</th>
          </tr>
        </thead>
        <tbody>
          {combinations.map(({ size, member, quantity }, index) => (
            <tr key={index}>
              {hasMember && <td>{member || 'N/A'}</td>}
              {hasSize && <td>{size !== '無尺寸' ? size : ''}</td>}
              <td>{quantity}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    );
  };

  const generatePDF = async () => {
    const pdfDoc = await PDFDocument.create();
    
    // Register fontkit instance
    pdfDoc.registerFontkit(fontkit);

    // Load and embed the font
    const fontBytes = await fetch(fontUrl).then((res) => res.arrayBuffer());
    const customFont = await pdfDoc.embedFont(fontBytes);

    // Set A4 page size: 595.28 x 841.89 points
    const page = pdfDoc.addPage([595.28, 841.89]);
    const { height } = page.getSize();

    let yPosition = height - 50;

    page.drawText('分類訂單統計', { x: 50, y: yPosition, size: 20, font: customFont, color: rgb(0, 0, 0) });
    yPosition -= 40;

    Object.entries(stats).forEach(([productId, data]) => {
      page.drawText(`${data.name}`, { x: 50, y: yPosition, size: 16, font: customFont, color: rgb(0, 0, 0) });
      yPosition -= 20;
      page.drawText(`總數量: ${data.totalQuantity}`, { x: 50, y: yPosition, size: 14, font: customFont, color: rgb(0, 0, 0) });
      yPosition -= 20;

      const combinations = Object.entries(data.sizeMemberCombinations)
        .map(([key, quantity]) => {
          const [size, member] = key.split('-');
          return { size, member, quantity };
        })
        .sort((a, b) => {
          if (a.member < b.member) return -1;
          if (a.member > b.member) return 1;
          if (a.size < b.size) return -1;
          if (a.size > b.size) return 1;
          return 0;
        });

      const hasSize = combinations.some((combination) => combination.size && combination.size !== '無尺寸');
      
      combinations.forEach(({ size, member, quantity }) => {
        let text = `成員: ${member || 'N/A'}, 數量: ${quantity}`;
        if (hasSize) {
          text = `成員: ${member || 'N/A'}, 尺寸: ${size !== '無尺寸' ? size : ''}, 數量: ${quantity}`;
        }
        page.drawText(text, { x: 50, y: yPosition, size: 12, font: customFont, color: rgb(0, 0, 0) });
        yPosition -= 20;
      });

      yPosition -= 20;
    });

    const pdfBytes = await pdfDoc.save();
    download(pdfBytes, `category_order_stats_${categoryId}.pdf`, 'application/pdf');
  };

  return (
    <Container>
      {error && <Alert variant="danger">{error}</Alert>}
      <h1>分類訂單統計</h1>
      <Button variant="primary" onClick={generatePDF}>導出PDF</Button>
      {Object.keys(stats).length === 0 ? (
        <p>沒有找到相關訂單</p>
      ) : (
        Object.entries(stats).map(([productId, data]) => (
          <div key={productId}>
            <h3>{data.name}</h3>
            <p>總數量: {data.totalQuantity}</p>
            {renderTable(data)}
          </div>
        ))
      )}
    </Container>
  );
};

export default CategoryOrderStats;
